export const DEFAULT_TYPE_USER = "admin";
